import * as i0 from '@angular/core';
import { Pipe, Component, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from '@dch/ng-common';

class DecimalPartPipe {
    constructor(languageService) {
        this.languageService = languageService;
    }
    transform(numberToFormat) {
        let decimalPart;
        const regexp = /[.](.*)$/;
        if (numberToFormat && parseFloat(numberToFormat) !== 0) {
            const match = regexp.exec(numberToFormat);
            if (match != null) {
                decimalPart = match[0].toString();
                decimalPart =
                    this.languageService.getSelectedLanguage() !== 'en'
                        ? decimalPart.replace('.', ',')
                        : decimalPart;
                // We check and add an extra zero to make sure the amount always has 2 digits after the comma
                if (decimalPart.length === 2) {
                    decimalPart += '0';
                }
            }
            else {
                decimalPart =
                    this.languageService.getSelectedLanguage() !== 'en' ? ',00' : '.00';
            }
        }
        else if (numberToFormat && parseFloat(numberToFormat) == 0) {
            decimalPart =
                this.languageService.getSelectedLanguage() !== 'en' ? ',00' : '.00';
        }
        return decimalPart;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: DecimalPartPipe, deps: [{ token: i1.LanguageService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: DecimalPartPipe, isStandalone: false, name: "decimalPart" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: DecimalPartPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'decimalPart',
                    standalone: false,
                }]
        }], ctorParameters: () => [{ type: i1.LanguageService }] });

class IntegerPartPipe {
    transform(numberToFormat) {
        let integerPart;
        if (numberToFormat) {
            integerPart = parseInt(numberToFormat, 10);
        }
        return integerPart;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: IntegerPartPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: IntegerPartPipe, isStandalone: false, name: "integerPart" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: IntegerPartPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'integerPart',
                    standalone: false,
                }]
        }] });

class PxCurrencyAmountComponent {
    constructor(languageService) {
        this.languageService = languageService;
        this.currency = '€';
    }
    ngOnChanges() {
        this.isNegativeAmount = parseFloat(this.amount) < 0;
        this.amountFull = this.amount.replace('-', '');
        this.currencySpace =
            this.languageService.getSelectedLanguage() === 'en' ? '' : ' ';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PxCurrencyAmountComponent, deps: [{ token: i1.LanguageService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: PxCurrencyAmountComponent, isStandalone: false, selector: "px-currency-amount", inputs: { amount: "amount", amountClass: "amountClass", currency: "currency", positive: "positive" }, usesOnChanges: true, ngImport: i0, template: "<span *ngIf=\"amountClass\" [class]=\"amountClass\">\n    <span *ngIf=\"positive\" class=\"rs-txt-warning\">+</span>\n    <span class=\"rs-nowrap\" *ngIf=\"amountFull\">\n        <span class=\"rs-euro\">{{isNegativeAmount?'- ':''}}{{currency}}{{currencySpace}}</span>\n        <span class=\"rs-unit\">{{amountFull | integerPart}}</span>\n        <span class=\"rs-decimal\">{{amountFull | decimalPart}}</span>\n    </span>\n</span>\n<span *ngIf=\"!amountClass\">\n    {{positive?'+':''}}{{isNegativeAmount?'- ':''}}{{currency}}{{currencySpace}}{{amountFull| integerPart}}{{amountFull| decimalPart}}\n</span>", dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: DecimalPartPipe, name: "decimalPart" }, { kind: "pipe", type: IntegerPartPipe, name: "integerPart" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PxCurrencyAmountComponent, decorators: [{
            type: Component,
            args: [{ selector: 'px-currency-amount', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<span *ngIf=\"amountClass\" [class]=\"amountClass\">\n    <span *ngIf=\"positive\" class=\"rs-txt-warning\">+</span>\n    <span class=\"rs-nowrap\" *ngIf=\"amountFull\">\n        <span class=\"rs-euro\">{{isNegativeAmount?'- ':''}}{{currency}}{{currencySpace}}</span>\n        <span class=\"rs-unit\">{{amountFull | integerPart}}</span>\n        <span class=\"rs-decimal\">{{amountFull | decimalPart}}</span>\n    </span>\n</span>\n<span *ngIf=\"!amountClass\">\n    {{positive?'+':''}}{{isNegativeAmount?'- ':''}}{{currency}}{{currencySpace}}{{amountFull| integerPart}}{{amountFull| decimalPart}}\n</span>" }]
        }], ctorParameters: () => [{ type: i1.LanguageService }], propDecorators: { amount: [{
                type: Input
            }], amountClass: [{
                type: Input
            }], currency: [{
                type: Input
            }], positive: [{
                type: Input
            }] } });

class CurrencyAmountModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CurrencyAmountModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: CurrencyAmountModule, declarations: [PxCurrencyAmountComponent, DecimalPartPipe, IntegerPartPipe], imports: [CommonModule], exports: [PxCurrencyAmountComponent, DecimalPartPipe, IntegerPartPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CurrencyAmountModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CurrencyAmountModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [PxCurrencyAmountComponent, DecimalPartPipe, IntegerPartPipe],
                    exports: [PxCurrencyAmountComponent, DecimalPartPipe, IntegerPartPipe],
                    imports: [CommonModule],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { CurrencyAmountModule, DecimalPartPipe, IntegerPartPipe, PxCurrencyAmountComponent };
